import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    Paper,
    Tabs,
    Tab,
    TextField,
    Button,
    Alert,
    AlertTitle,
    CircularProgress,
    Breadcrumbs,
    Link as MuiLink,
    FormControl,
    Select as MuiSelect,
    Card,
    CardContent,
    Chip,
    Divider
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PeopleIcon from '@mui/icons-material/People';
import EmailIcon from '@mui/icons-material/Email';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import SendIcon from '@mui/icons-material/Send';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import { isAuthenticated } from "../auth";
import {
    singleGroup, addUsertoGroup, removeUserFromGroup,
    sendMessage, loadSurveyData, groupDetails, updateGroup
} from "../group/apigroup";
import { list, listForGroup } from "../user/apiUser"
import Select from 'react-select'
import { Redirect, Link } from "react-router-dom";
import moment from "moment";
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';
import EventCalendar from "../event/EventCalendar";
import Footer from '../core/Footer';
import MonthlyCallsManager from './monthylReport';


function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`admin-tabpanel-${index}`}
            aria-labelledby={`admin-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

class AdminGroup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            groupId: this.props.match.params.groupId,
            currentUserId: isAuthenticated().userId,
            currentUserName: isAuthenticated().name,
            currentUserEmail: isAuthenticated().email,
            token: isAuthenticated().token,
            groupChairId: '',
            groupCoChairId: '',
            group: '',
            mainResourceName: 'general',
            eventResourceName: 'general',
            calendarName: 'General',
            redirectToHome: false,
            redirectToSignin: false,
            chair: '',
            cochair: '',
            members: [],
            allUsers: [],
            userToAdd: '',
            groupMessage: '',
            groupName: '',
            groupMessageSubject: '',
            editorState: EditorState.createEmpty(),
            emailSuccess: false,
            SurveyData: [],
            removeMember: true,
            userTorRemove: '',
            memberSort: null,
            memberAdded: false,
            memberRemoved: false,
            submittedEmail: false,
            sending: false,
            activeTab: 0,
            editName: '',
            editDescription: '',
            savingSettings: false,
            settingsSuccess: false,
            settingsError: ''
        };
        this.verifyAdmin = this.verifyAdmin.bind(this);
        this.showSuccess = this.showSuccess.bind(this);
        this.removeUser = this.removeUser.bind(this);
    }


    componentWillMount = () => {


        singleGroup(this.props.match.params.groupId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {

                this.setState({
                    group: data
                });
            }
        });


        groupDetails(this.props.match.params.groupId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    chair: data.chair.name + " " + data.chair.lastName,
                    groupChairId: data.chair._id,
                    groupCoChairId: data.cochair._id,
                    cochair: data.cochair.name,
                    members: data.members,
                    groupName: data.name,
                    editName: data.name || '',
                    editDescription: data.description || ''
                })
            }

        });


        listForGroup(this.props.match.params.groupId).then(uniqueUsers => {
            if (uniqueUsers.error) {
                console.log(uniqueUsers.error);
            } else {
                this.setState({
                    allUsers: uniqueUsers
                })
            }
        })

        if (this.props.match.params.groupId === '5e5591a97ff73f6d34835a05') { this.setState({ mainResourceName: 'General Committee', calendarName: 'General' }) }
        if (this.props.match.params.groupId === '5e2a5e764175b97d84ec6cae') { this.setState({ mainResourceName: 'Physical Committee', calendarName: 'Physical' }) }
        if (this.props.match.params.groupId === '5e44050f4e6ed37ab467d0f2') { this.setState({ mainResourceName: 'Electrical Committee', calendarName: 'Electrical' }) }
        if (this.props.match.params.groupId === '5e44052e4e6ed37ab467d0f3') { this.setState({ mainResourceName: 'Technology Committee', calendarName: 'Technology' }) }
        if (this.props.match.params.groupId === '5e4405864e6ed37ab467d0f4') { this.setState({ mainResourceName: 'Civil Committee', calendarName: 'Civil' }) }
        if (this.props.match.params.groupId === '5e4406454e6ed37ab467d0f5') { this.setState({ mainResourceName: 'Business Strategy Committee', calendarName: 'Business' }) }
        if (this.props.match.params.groupId === '639242d4971a30726884fd85') { this.setState({ mainResourceName: 'Innovation Commitee', calendarName: 'Innovation' }) }

        loadSurveyData(this.state.token).then(surveyResults => {
            if (surveyResults.error) {
                console.log(surveyResults.error);
            } else {
                this.setState({
                    SurveyData: surveyResults
                })
            }
        })

        this.setState({ eventResourceName: 'General Sessions' })
    }

    handleChange = name => event => {
        let value = "";
        if (name === 'userToAdd') {
            value = event.value
        } else {
            value = event.target.value
        }
        this.setState({ [name]: value });
        this.setState({ submittedEmail: true })
    };

    onChange = (editorState) => this.setState({ editorState });

    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    };


    addedMessage() {
        if (!this.state.memberAdded) return null;
        return (
            <Alert severity="success" variant="filled" sx={{ mb: 3 }}>
                <AlertTitle sx={{ fontWeight: 700 }}>Success!</AlertTitle>
                Member was added successfully to the committee.
            </Alert>
        )
    };

    removedMessage() {
        if (!this.state.memberRemoved) return null;
        return (
            <Alert severity="success" variant="filled" sx={{ mb: 3 }}>
                <AlertTitle sx={{ fontWeight: 700 }}>Success!</AlertTitle>
                Member was removed successfully from the committee.
            </Alert>
        )
    };

    addUser = e => {
        e.preventDefault();
        const token = isAuthenticated().token;
        if (this.state.userToAdd) {
            addUsertoGroup(token, this.props.match.params.groupId, this.state.userToAdd).then(data => {
                if (data.error) {
                    console.log(data.error);
                } else {
                    this.setState({
                        userToAdd: '',
                        memberAdded: true,
                        memberRemoved: false
                    });
                    singleGroup(this.props.match.params.groupId).then(data => {
                        if (data.error) {
                            console.log(data.error);
                        } else {

                            this.setState({
                                group: data
                            });
                        }
                    });

                    groupDetails(this.props.match.params.groupId).then(data => {
                        if (data.error) {
                            console.log(data.error);
                        } else {
                            this.setState({
                                chair: data.chair.name + " " + data.chair.lastName,
                                groupChairId: data.chair._id,
                                groupCoChairId: data.cochair._id,
                                cochair: data.cochair.name,
                                members: data.members,
                                groupName: data.name
                            })
                        }

                    });
                }
            });
        }

    };

    saveSettings = (e) => {
        e.preventDefault();

        const name = this.state.editName.trim();
        const description = this.state.editDescription.trim();

        if (!name || !description) {
            this.setState({ settingsError: 'Both committee name and description are required.', settingsSuccess: false });
            return;
        }

        this.setState({ savingSettings: true, settingsSuccess: false, settingsError: '' });

        updateGroup(this.props.match.params.groupId, this.state.currentUserId, { name, description }).then(data => {
            if (data.error) {
                this.setState({ savingSettings: false, settingsError: data.error, settingsSuccess: false });
            } else {
                this.setState({
                    savingSettings: false,
                    settingsSuccess: true,
                    settingsError: '',
                    groupName: data.name,
                    group: { ...this.state.group, name: data.name, description: data.description }
                });
            }
        });
    };

    sendGroupMessage = async (e) => {
        e.preventDefault();
        if (this.state.sending) return;

        this.setState({ sending: true, emailSuccess: false });

        try {
            const rawState = stateToHTML(this.state.editorState.getCurrentContent());

            const uniqueEmails = Array.from(
                this.state.members
                    .map(m => (m.email ? m.email.trim() : ''))
                    .filter(Boolean)
                    .reduce((set, e) => set.add(e), new Set())
            )

            const mailMessage = {
                "subject": this.state.groupMessageSubject,
                "from": "donotreply@sdsconsortium.com",
                "to": "donotreply@sdsconsortium.com",
                "bcc": uniqueEmails,
                "text": `Group Message from the ${this.state.groupName} ${rawState}`,
                "html": `<html><body><h4>Group Message from the ${this.state.groupName},</h4>${rawState}</body></html>`
            }

            // The endpoint used to never respond, so this waited a fixed 10s and
            // assumed the best. It returns a real status now, so await it.
            const result = await sendMessage(mailMessage);
            if (!result || result.error) {
                throw new Error(result && result.error ? result.error : 'The mail server did not confirm the send.');
            }

            this.setState({
                groupMessage: '',
                groupMessageSubject: '',
                editorState: EditorState.createEmpty(),
                submittedEmail: false,
                emailSuccess: true
            });
        } catch (err) {
            console.error(err);
            alert(`Message could not be sent, please try again. (${err.message})`);
        } finally {
            this.setState({ sending: false });
        }
    };

    emptyData() {
        if (this.state.SurveyData.length === 0) {
            return (
                <Alert severity="info" sx={{ mb: 2 }}>
                    There is no survey data yet!
                </Alert>
            )
        }
    }

    showSuccess() {
        if (!this.state.emailSuccess) return null;
        return (
            <Alert severity="success" variant="filled" sx={{ mb: 3 }}>
                <AlertTitle sx={{ fontWeight: 700 }}>Email Sent Successfully!</AlertTitle>
                Your message has been sent to all {this.state.members.length} committee members.
            </Alert>
        )
    };

    calendarTypeChange = name => event => {

        this.setState({ calendarName: event.target.value });
    };

    formatResponse(question, id, label, ans) {

        if (label === '') { label = ' ______ ' }
        switch (question) {
            case 'question1':
                return (<p>Is your company currently approving corporate travel for 2022? <b>{label}</b></p>)
            case 'question2':
                return (<p>Are you expecting that your company will approve corporate travel to Kansas City for the 2022 meeting of the SDSIC? <b>{label}</b></p>)
            case 'question3':
                return (<p>If approved, do you plan to attend the meeting in May? <b>{label}</b></p>)
            case 'question4':
                return (
                    <>
                        <p>
                            The meeting will be held Tuesday, May 3rd thru Thursday May 5th. At past events we included a ½ day session on Monday, to introduce new members to the SDSIC suite of tools.
                        </p>
                        <p>
                            Is this new member session something you have found to be beneficial in the past? <b>{label}</b>
                        </p>
                    </>)
            case 'question5':
                return (<><p>If this session is held Monday afternoon, would it be something you will attend? <b>{label}</b></p></>)
            case 'question6':
                return (<p>How many meetings of the SDSIC have you personally attended? <b>{ans.question6}</b></p>)
            case 'question7':
                return (<p>What would you most like to see included in the event. For example, project spotlights, how-to's, round table discussions <b>{ans.question7}</b></p>)
            case 'question8':
                return (<p>Will you be using the SDSIC meeting suggested accommodations or book thru your corporate travel desk? <b>{ans.question8}</b></p>)
            default:
                return null;
        }

    };

    removeUser() {
        const token = isAuthenticated().token;

        removeUserFromGroup(token, this.state.groupId, this.state.userTorRemove).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    removeMember: true,
                    memberId: '',
                    memberAdded: false,
                    memberRemoved: true
                });
                singleGroup(this.props.match.params.groupId).then(data => {
                    if (data.error) {
                        console.log(data.error);
                    } else {

                        this.setState({
                            group: data
                        });
                    }
                });

                groupDetails(this.props.match.params.groupId).then(data => {
                    if (data.error) {
                        console.log(data.error);
                    } else {
                        this.setState({
                            chair: data.chair.name + " " + data.chair.lastName,
                            groupChairId: data.chair._id,
                            groupCoChairId: data.cochair._id,
                            cochair: data.cochair.name,
                            members: data.members,
                            groupName: data.name
                        })
                    }

                });
            }
        });

    };

    handleMemberChange(memberId) {
        this.setState({
            removeMember: false,
            userTorRemove: memberId,
            memberAdded: false,
            memberRemoved: false
        })
    };


    sortMembers = members => {
        const { memberSort } = this.state;
        if (!memberSort) return members;
        const direction = memberSort === 'desc' ? -1 : 1;
        return [...members].sort((a, b) =>
            direction * (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
        );
    };


    verifyAdmin(chairId, cochairId, userId, chair, cochair, members, users) {
        const uniqueUsers = Array.from(new Map(users.map(user => [user._id, user])).values());
        const sortedMembers = this.sortMembers(members);
        const sortButtonSx = active => ({
            minWidth: 0,
            px: 1.25,
            py: 0.25,
            textTransform: 'none',
            fontWeight: 600,
            borderColor: '#003E7E',
            color: active ? '#fff' : '#003E7E',
            backgroundColor: active ? '#003E7E' : 'transparent',
            '&:hover': {
                backgroundColor: active ? '#00305F' : 'rgba(0, 62, 126, 0.08)',
                borderColor: '#003E7E'
            }
        });

        if (chairId === userId || cochairId === userId || isAuthenticated().role === 'admin') {

            return (
                <>
                    {/* Modern Hero Header */}
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #003E7E 0%, #0056A8 100%)',
                            color: 'white',
                            py: 6,
                            mb: 4,
                            borderRadius: 3,
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                width: '300px',
                                height: '300px',
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.05)',
                                top: '-100px',
                                right: '-50px',
                            }}
                        />
                        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
                                <AdminPanelSettingsIcon sx={{ fontSize: { xs: 32, sm: 48 }, mr: { xs: 0, sm: 2 } }} />
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 700, fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' } }}>
                                    {this.state.groupName} Admin
                                </Typography>
                            </Box>
                            <Typography variant="h6" sx={{ opacity: 0.9, mb: 2 }}>
                                All modifications and communications on this page will be live for all committee members.
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                <Chip
                                    icon={<PeopleIcon />}
                                    label={`Logged in as: ${this.state.currentUserName}`}
                                    sx={{
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                        color: 'white',
                                        fontWeight: 600,
                                        backdropFilter: 'blur(10px)',
                                    }}
                                />
                                <Chip
                                    label={`Committee Chair: ${chair}`}
                                    sx={{
                                        backgroundColor: 'rgba(255, 102, 0, 0.9)',
                                        color: 'white',
                                        fontWeight: 600,
                                    }}
                                />
                                <Chip
                                    label={`${members.length} Members`}
                                    sx={{
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                        color: 'white',
                                        fontWeight: 600,
                                        backdropFilter: 'blur(10px)',
                                    }}
                                />
                            </Box>
                        </Container>
                    </Box>

                    <Container maxWidth="lg">
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            sx={{
                                my: 3,
                                '& .MuiLink-root': {
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }
                            }}
                        >
                            <MuiLink component={Link} to="/usershome" color="inherit">
                                Home
                            </MuiLink>
                            <MuiLink component={Link} to={`/singlegroup/${this.props.match.params.groupId}`} color="inherit">
                                Back to committee
                            </MuiLink>
                            <Typography color="text.primary" sx={{ fontWeight: 600 }}>Group Admin</Typography>
                        </Breadcrumbs>

                        {/* Success Messages */}
                        {this.addedMessage()}
                        {this.removedMessage()}

                        {/* Tabs Container */}
                        <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#f8f9fa' }}>
                                <Tabs
                                    value={this.state.activeTab}
                                    onChange={this.handleTabChange}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    sx={{
                                        '& .MuiTab-root': {
                                            fontWeight: 600,
                                            fontSize: { xs: '0.85rem', sm: '1rem' },
                                            textTransform: 'none',
                                            minHeight: { xs: '56px', sm: '72px' },
                                            '&.Mui-selected': {
                                                color: '#FF6600'
                                            }
                                        },
                                        '& .MuiTabs-indicator': {
                                            backgroundColor: '#FF6600',
                                            height: 3
                                        }
                                    }}
                                >
                                    <Tab icon={<CalendarMonthIcon />} iconPosition="start" label="Meeting Calendar" />
                                    <Tab icon={<PeopleIcon />} iconPosition="start" label="Members" />
                                    <Tab icon={<EmailIcon />} iconPosition="start" label="Group Message" />
                                    <Tab icon={<AssessmentIcon />} iconPosition="start" label="Monthly Recordings" />
                                    <Tab icon={<SettingsIcon />} iconPosition="start" label="Settings" />
                                </Tabs>
                            </Box>

                            {/* Tab 0: Meeting Calendar */}
                            <TabPanel value={this.state.activeTab} index={0}>
                                <Card elevation={0} sx={{ backgroundColor: '#f8f9fa', p: 2, borderRadius: 2 }}>
                                    <Typography variant="h5" sx={{ fontWeight: 700, color: '#003E7E', mb: 3 }}>
                                        {this.state.group.name} Meeting Calendar
                                    </Typography>
                                    <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 2 }}>
                                        <EventCalendar
                                            scheduleName={this.state.calendarName}
                                            isAdmin={true}
                                            chooseTracks={false}
                                            chooseDays={false}
                                            currentDate={moment().format("YYYY-MM-DD")}
                                            excludedDays={[0, 6, 7]}
                                            weekView={false}
                                            resourceList={this.getresourceList()}
                                            mainResourceName={this.state.mainResourceName}
                                        />
                                    </Box>
                                </Card>
                            </TabPanel>

                            {/* Tab 1: Members Management */}
                            <TabPanel value={this.state.activeTab} index={1}>
                                <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', md: 'row' } }}>
                                    {/* Remove Members Section */}
                                    <Card elevation={2} sx={{ flex: 1, borderRadius: 3 }}>
                                        <CardContent sx={{ p: 3 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                <PersonRemoveIcon sx={{ color: '#FF6600', mr: 1, fontSize: 28 }} />
                                                <Typography variant="h6" sx={{ fontWeight: 700, color: '#003E7E' }}>
                                                    Remove Members
                                                </Typography>
                                            </Box>
                                            <Divider sx={{ mb: 2 }} />
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                                                <Typography variant="body2" color="text.secondary">
                                                    {members.length} Current Members
                                                </Typography>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <SortByAlphaIcon sx={{ color: '#003E7E', fontSize: 20, mr: 0.5 }} />
                                                    <Button
                                                        onClick={() => this.setState({ memberSort: 'asc' })}
                                                        size="small"
                                                        variant="outlined"
                                                        title="Sort members A to Z"
                                                        sx={sortButtonSx(this.state.memberSort === 'asc')}
                                                    >
                                                        A-Z
                                                    </Button>
                                                    <Button
                                                        onClick={() => this.setState({ memberSort: 'desc' })}
                                                        size="small"
                                                        variant="outlined"
                                                        title="Sort members Z to A"
                                                        sx={sortButtonSx(this.state.memberSort === 'desc')}
                                                    >
                                                        Z-A
                                                    </Button>
                                                </Box>
                                            </Box>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <MuiSelect
                                                    onChange={e => { this.handleMemberChange(e.target.value) }}
                                                    multiple
                                                    native
                                                    sx={{
                                                        minHeight: '180px',
                                                        borderRadius: 2,
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#003E7E'
                                                        }
                                                    }}
                                                    inputProps={{ style: { height: '160px' } }}
                                                >
                                                    {sortedMembers.map(d =>
                                                        <option key={d._id} value={d._id}>{d.name} - {d.email}</option>
                                                    )}
                                                </MuiSelect>
                                            </FormControl>
                                            <Button
                                                onClick={this.removeUser}
                                                variant="contained"
                                                disabled={this.state.removeMember}
                                                startIcon={<PersonRemoveIcon />}
                                                fullWidth
                                                sx={{
                                                    backgroundColor: '#d32f2f',
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                    py: 1.5,
                                                    '&:hover': {
                                                        backgroundColor: '#b71c1c'
                                                    },
                                                    '&:disabled': {
                                                        backgroundColor: '#ccc'
                                                    }
                                                }}
                                            >
                                                Remove Selected Member
                                            </Button>
                                        </CardContent>
                                    </Card>

                                    {/* Add Members Section */}
                                    <Card elevation={2} sx={{ flex: 1, borderRadius: 3 }}>
                                        <CardContent sx={{ p: 3 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                <PersonAddIcon sx={{ color: '#4caf50', mr: 1, fontSize: 28 }} />
                                                <Typography variant="h6" sx={{ fontWeight: 700, color: '#003E7E' }}>
                                                    Add Members
                                                </Typography>
                                            </Box>
                                            <Divider sx={{ mb: 2 }} />
                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                {uniqueUsers.length} Active SDSIC Members Available
                                            </Typography>
                                            <Box component="form" onSubmit={this.addUser}>
                                                <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                                                    Search for Users:
                                                </Typography>
                                                <Select
                                                    name="userToAdd"
                                                    options={uniqueUsers.map((c, i) => (
                                                        {
                                                            value: c._id,
                                                            label: `${c.name} ${c.lastName} - ${c.email}`
                                                        }
                                                    ))}
                                                    onChange={this.handleChange("userToAdd")}
                                                    isSearchable={true}
                                                    placeholder='Type a name or email to search...'
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '48px',
                                                            borderRadius: '8px',
                                                            borderColor: '#003E7E'
                                                        })
                                                    }}
                                                />
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    fullWidth
                                                    startIcon={<PersonAddIcon />}
                                                    sx={{
                                                        mt: 2,
                                                        backgroundColor: '#4caf50',
                                                        textTransform: 'none',
                                                        fontWeight: 600,
                                                        py: 1.5,
                                                        '&:hover': {
                                                            backgroundColor: '#388e3c'
                                                        }
                                                    }}
                                                >
                                                    Add User to Committee
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </TabPanel>

                            {/* Tab 2: Group Message */}
                            <TabPanel value={this.state.activeTab} index={2}>
                                <Card elevation={0} sx={{ backgroundColor: '#f8f9fa', p: 3, borderRadius: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                        <EmailIcon sx={{ color: '#FF6600', mr: 1, fontSize: 32 }} />
                                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#003E7E' }}>
                                            Send Email to All Committee Members
                                        </Typography>
                                    </Box>

                                    {this.showSuccess()}

                                    {!this.state.emailSuccess && (
                                        <Box component="form" onSubmit={this.sendGroupMessage}>
                                            <TextField
                                                fullWidth
                                                label="Email Subject"
                                                value={this.state.groupMessageSubject}
                                                onChange={this.handleChange('groupMessageSubject')}
                                                margin="normal"
                                                variant="outlined"
                                                required
                                                sx={{
                                                    backgroundColor: 'white',
                                                    borderRadius: 2,
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: 2
                                                    }
                                                }}
                                            />

                                            <Box sx={{ my: 3, backgroundColor: 'white', borderRadius: 2, overflow: 'hidden' }}>
                                                <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, px: 2, pt: 2 }}>
                                                    Message Content:
                                                </Typography>
                                                <Editor
                                                    editorState={this.state.editorState}
                                                    wrapperClassName="demo-wrapper"
                                                    editorClassName="editer-content"
                                                    onEditorStateChange={this.onChange}
                                                    wrapperStyle={{ border: "2px solid #003E7E", borderRadius: "8px" }}
                                                    editorStyle={{ height: "300px", padding: "10px" }}
                                                />
                                            </Box>

                                            {this.state.sending && (
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: '#fff3e0',
                                                    p: 3,
                                                    borderRadius: 2,
                                                    mb: 2
                                                }}>
                                                    <CircularProgress size={48} sx={{ color: '#FF6600' }} />
                                                    <Typography variant="h6" sx={{ ml: 2, color: '#FF6600', fontWeight: 700 }}>
                                                        Sending to {this.state.members.length} members...
                                                    </Typography>
                                                </Box>
                                            )}

                                            <Button
                                                type="submit"
                                                variant="contained"
                                                size="large"
                                                disabled={this.state.sending || !this.state.submittedEmail}
                                                startIcon={<SendIcon />}
                                                sx={{
                                                    backgroundColor: '#FF6600',
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                    py: 1.5,
                                                    px: 4,
                                                    fontSize: '1.1rem',
                                                    borderRadius: 2,
                                                    '&:hover': {
                                                        backgroundColor: '#e55a00'
                                                    },
                                                    '&:disabled': {
                                                        backgroundColor: '#ccc'
                                                    }
                                                }}
                                            >
                                                Send Email to All Members
                                            </Button>
                                        </Box>
                                    )}
                                </Card>
                            </TabPanel>

                            {/* Tab 3: Monthly Calls */}
                            <TabPanel value={this.state.activeTab} index={3}>
                                <MonthlyCallsManager groupId={this.props.match.params.groupId} />
                            </TabPanel>

                            {/* Tab 4: Committee Settings */}
                            <TabPanel value={this.state.activeTab} index={4}>
                                <Card elevation={0} sx={{ backgroundColor: '#f8f9fa', p: 3, borderRadius: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                        <SettingsIcon sx={{ color: '#FF6600', mr: 1, fontSize: 32 }} />
                                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#003E7E' }}>
                                            Edit Committee Details
                                        </Typography>
                                    </Box>

                                    {this.state.settingsSuccess && (
                                        <Alert severity="success" variant="filled" sx={{ mb: 3 }}>
                                            <AlertTitle sx={{ fontWeight: 700 }}>Saved!</AlertTitle>
                                            Committee details were updated successfully.
                                        </Alert>
                                    )}
                                    {this.state.settingsError && (
                                        <Alert severity="error" variant="filled" sx={{ mb: 3 }}>
                                            <AlertTitle sx={{ fontWeight: 700 }}>Could not save</AlertTitle>
                                            {this.state.settingsError}
                                        </Alert>
                                    )}

                                    <Box component="form" onSubmit={this.saveSettings}>
                                        <TextField
                                            fullWidth
                                            label="Committee Name"
                                            value={this.state.editName}
                                            onChange={this.handleChange('editName')}
                                            margin="normal"
                                            variant="outlined"
                                            required
                                            inputProps={{ maxLength: 100 }}
                                            sx={{ backgroundColor: 'white', borderRadius: 2 }}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Committee Description"
                                            value={this.state.editDescription}
                                            onChange={this.handleChange('editDescription')}
                                            margin="normal"
                                            variant="outlined"
                                            required
                                            multiline
                                            rows={6}
                                            inputProps={{ maxLength: 2000 }}
                                            sx={{ backgroundColor: 'white', borderRadius: 2 }}
                                        />
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            size="large"
                                            disabled={this.state.savingSettings}
                                            startIcon={this.state.savingSettings ? <CircularProgress size={20} color="inherit" /> : <SettingsIcon />}
                                            sx={{
                                                mt: 2,
                                                backgroundColor: '#FF6600',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                py: 1.5,
                                                px: 4,
                                                '&:hover': { backgroundColor: '#e55a00' },
                                                '&:disabled': { backgroundColor: '#ccc' }
                                            }}
                                        >
                                            {this.state.savingSettings ? 'Saving...' : 'Save Changes'}
                                        </Button>
                                    </Box>
                                </Card>
                            </TabPanel>
                        </Paper>
                    </Container>
                </>
            )
        } else {
            return (
                <Container maxWidth="sm">
                    <Box sx={{ mt: 8, mb: 8 }}>
                        <Alert
                            severity="error"
                            variant="filled"
                            sx={{
                                borderRadius: 3,
                                fontSize: '1rem'
                            }}
                        >
                            <AlertTitle sx={{ fontWeight: 700, fontSize: '1.2rem' }}>
                                Access Denied
                            </AlertTitle>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                Sorry {this.state.currentUserName}, you do not have permission to administer the {this.state.group.name}.
                            </Typography>
                            <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Only the committee chair and co-chair can access this page.
                            </Typography>
                        </Alert>
                        <Box sx={{ textAlign: 'center', mt: 3 }}>
                            <Button
                                component={Link}
                                to={`/singlegroup/${this.props.match.params.groupId}`}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#003E7E',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    px: 4,
                                    '&:hover': {
                                        backgroundColor: '#00325a'
                                    }
                                }}
                            >
                                Back to Committee Page
                            </Button>
                        </Box>
                    </Box>
                </Container>
            )
        }
    };



    getresourceList() {
        switch (this.props.match.params.groupId) {
            case '5e2a5e764175b97d84ec6cae':
                return (
                    [
                        {
                            fieldName: 'physical',
                            title: 'Physical Committee',
                            allowMultiple: true,
                            instances: [
                                { id: 1, text: 'Committee Update', color: '#993399' },
                                { id: 2, text: 'Monthly Meeting', color: '#993399' },
                                { id: 3, text: 'Committee Presentation', color: '#993399' },
                                { id: 4, text: 'Vendor Presentation', color: '#993399' },
                                { id: 5, text: 'Committee Round Table', color: '#993399' },
                                { id: 6, text: 'User Presentation', color: '#993399' },
                                { id: 7, text: 'Best Practice Discussion', color: '#993399' },
                                { id: 8, text: 'Committee Closing Session', color: '#993399' },
                                { id: 9, text: 'IACET Presentation', color: '#993399' }
                            ]
                        }
                    ]
                )
            case '5e44050f4e6ed37ab467d0f2':
                return (
                    [
                        {
                            fieldName: 'electrical',
                            title: 'Electrical Committee',
                            allowMultiple: true,
                            instances: [
                                { id: 1, text: 'Committee Update', color: '#f44336' },
                                { id: 2, text: 'Monthly Meeting', color: '#f44336' },
                                { id: 3, text: 'Committee Presentation', color: '#f44336' },
                                { id: 4, text: 'Vendor Presentation', color: '#f44336' },
                                { id: 5, text: 'Committee Round Table', color: '#f44336' },
                                { id: 6, text: 'User Presentation', color: '#f44336' },
                                { id: 7, text: 'Best Practice Discussion', color: '#f44336' },
                                { id: 8, text: 'Committee Closing Session', color: '#f44336' },
                                { id: 9, text: 'IACET Presentation', color: '#f44336' }
                            ],
                        }
                    ]
                )
            case '5e44052e4e6ed37ab467d0f3':

                return (
                    [
                        {
                            fieldName: 'technology',
                            title: 'Technology Committee',
                            allowMultiple: true,
                            instances: [
                                { id: 1, text: 'Committee Update', color: '#339966' },
                                { id: 2, text: 'Monthly Meeting', color: '#339966' },
                                { id: 3, text: 'Committee Presentation', color: '#339966' },
                                { id: 4, text: 'Vendor Presentation', color: '#339966' },
                                { id: 5, text: 'Committee Round Table', color: '#339966' },
                                { id: 6, text: 'User Presentation', color: '#339966' },
                                { id: 7, text: 'Best Practice Discussion', color: '#339966' },
                                { id: 8, text: 'Committee Closing Session', color: '#339966' },
                                { id: 9, text: 'IACET Presentation', color: '#339966' }
                            ],
                        }
                    ]
                )
            case '5e4405864e6ed37ab467d0f4':
                return (
                    [
                        {
                            fieldName: 'civil',
                            title: 'Civil Committee',
                            allowMultiple: true,
                            instances: [
                                { id: 1, text: 'Committee Update', color: '#795548' },
                                { id: 2, text: 'Monthly Meeting', color: '#795548' },
                                { id: 3, text: 'Committee Presentation', color: '#795548' },
                                { id: 4, text: 'Vendor Presentation', color: '#795548' },
                                { id: 5, text: 'Committee Round Table', color: '#795548' },
                                { id: 6, text: 'User Presentation', color: '#795548' },
                                { id: 7, text: 'Best Practice Discussion', color: '#795548' },
                                { id: 8, text: 'Committee Closing Session', color: '#795548' },
                                { id: 9, text: 'IACET Presentation', color: '#795548' }
                            ],
                        }
                    ]
                )
            case '5e4406454e6ed37ab467d0f5':
                return (
                    [
                        {
                            fieldName: 'bizstrategy',
                            title: 'Business Strategy Committee',
                            allowMultiple: true,
                            instances: [
                                { id: 1, text: 'Committee Update', color: '#000099' },
                                { id: 2, text: 'Monthly Meeting', color: '#000099' },
                                { id: 3, text: 'Committee Presentation', color: '#000099' },
                                { id: 4, text: 'Vendor Presentation', color: '#000099' },
                                { id: 5, text: 'Committee Round Table', color: '#000099' },
                                { id: 6, text: 'User Presentation', color: '#000099' },
                                { id: 7, text: 'Best Practice Discussion', color: '#000099' },
                                { id: 8, text: 'Committee Closing Session', color: '#000099' },
                                { id: 9, text: 'IACET Presentation', color: '#000099' }
                            ],
                        }
                    ]
                )
            default:

                return (
                    [
                        {
                            fieldName: 'general',
                            title: 'General Sessions',
                            allowMultiple: true,
                            instances: [
                                { id: 1, text: 'Committee Update', color: '#4caf50' },
                                { id: 2, text: 'Monthly Meeting', color: '#4caf50' },
                                { id: 3, text: 'Committee Presentation', color: '#4caf50' },
                                { id: 4, text: 'Vendor Presentation', color: '#4caf50' },
                                { id: 5, text: 'Committee Round Table', color: '#4caf50' },
                                { id: 6, text: 'User Presentation', color: '#4caf50' },
                                { id: 7, text: 'Best Practice Discussion', color: '#4caf50' },
                                { id: 8, text: 'Committee Closing Session', color: '#4caf50' },
                                { id: 9, text: 'IACET Presentation', color: '#4caf50' }

                            ],
                        }
                    ]
                )
        };
    };


    render() {


        if (this.state.redirectToHome) {
            return <Redirect to={`/singlegroup/${this.props.match.params.groupId}`} />;
        }
        return (


            <>
                <Box sx={{ minHeight: '80vh', py: 4, backgroundColor: '#f5f5f5' }}>
                    {this.verifyAdmin(this.state.groupChairId, this.state.groupCoChairId, this.state.currentUserId, this.state.chair, this.state.cochair, this.state.members, this.state.allUsers)}
                </Box>
                <Footer />
            </>

        )
    }
};

export default AdminGroup;
